import React from "react";

function SpendingHeaders() {
  return (
    <tr>
      <th>№</th>
      <th>ID</th>
      <th>Дата открытия</th>
      <th>Дата закрытия</th>
      <th>Кассир</th>
      <th>Наличка</th>
      <th></th>
    </tr>
  );
}

export default SpendingHeaders;
